export default {
  common: {
    unexpected: '发生了意外错误',
    tryAgain: '请稍后再试',
    refresh: '刷新页面'
  },
  network: {
    offline: '您似乎已离线',
    connectionLost: '连接已断开',
    serverError: '服务器错误',
    requestFailed: '请求失败'
  },
  game: {
    loadFailed: '无法加载游戏',
    unsupported: '您的浏览器可能不支持此游戏',
    missingDependencies: '缺少运行游戏所需的组件'
  },
  validation: {
    required: '此字段为必填项',
    email: '请输入有效的电子邮件地址',
    minLength: '请输入至少 {min} 个字符',
    maxLength: '不能超过 {max} 个字符'
  }
}; 